import { createReducer } from '@reduxjs/toolkit';
import { AssetLinkShape } from './model';
import * as assetLinkActions from './actions';
import * as finderActions from '../finder/actions';

const initial: AssetLinkShape = {
  inProgress: false,
};

export const assetLinkReducer = createReducer(initial, (builder) =>
  builder
    .addCase(assetLinkActions.setInProgress, (s, a) => {
      s.inProgress = a.payload.inProgress;
    })
    .addCase(finderActions.assetSelected, (s) => {
      s.inProgress = false;
    }),
);
